import '.ej{font-size:1.125rem;}.ssr-plugin'
import '.eo{line-height:1.75rem;}.ssr-plugin'
import '.e5{text-decoration:none;}.ssr-plugin'
import '.fk{color:var(--primary-red);}.ssr-plugin'
import { pages } from '@app/util/links'
import { useTranslations } from '@i18n/useLanguage'
import { styled } from 'inlines'

export const TermsAndConditions = () => {
  const translations = useTranslations().app.auth
  return (
    <p className="ej eo"
    >
      {translations.privacySubtitle}{' '}
      <a className="e5 fk"
        href={pages.legal}
        target="_blank"
        rel="noopener noreferrer"
      >
        {translations.privacyStatementLink}
      </a>{' '}
      {translations.privacySubtitleAnd}{' '}
      <a className="e5 fk"
        href={pages.legal}
        target="_blank"
        rel="noopener noreferrer"
      >
        {translations.termsAndConditionsLink}
      </a>
    </p>
  )
}
